/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import assets from './assets';
import folders from './folders';
import gdpr from './gdpr';
import channels from './epg/channels';
import playableChannels from './epg/playableChannels';
import topCannels from './epg/topChannels';
import tunedChannels from './epg/tunedChannels';
import region from './region';
import wishlist from './wishlist';
import consumption from './consumption';
import entitlements from './entitlements';
import recordings from './recordings';
import playbackLicense from './playbackLicense';
import folderLastWatchedContents from './folderLastWatchedContents';
import parentalControl from './parentalControl';
import contentSettings from './contentSettings';
import vodProductIdCache from './vodProductIdCache';
import ssm from './ssm';

export default {
  assets,
  folders,
  gdpr,
  channels,
  playableChannels,
  tunedChannels,
  region,
  wishlist,
  consumption,
  entitlements,
  recordings,
  topCannels,
  playbackLicense,
  folderLastWatchedContents,
  parentalControl,
  contentSettings,
  vodProductIdCache,
  ssm,
};
